/**
 * Package Limits Utility Functions
 * Bu dosya kullanıcının paket limitlerini kontrol etmek için kullanılır
 */

/**
 * Kullanıcının packageLimits array'inden belirli bir subject için limit kontrolü yapar
 * @param {string} subject - Kontrol edilecek subject (örn: 'PROJECTS')
 * @param {number} requiredLimit - Gerekli minimum limit değeri
 * @returns {boolean} - Limit kontrolü sonucu
 */
export const hasPackageLimit = (subject, requiredLimit = 1) => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))

    if (!userData || !userData.packageLimits || !Array.isArray(userData.packageLimits)) {
      return false
    }
    // packageLimits array'inde belirtilen subject ve limit değerini ara
    const limitItem = userData.packageLimits.find(item => item.subject === subject && item.limit >= requiredLimit)

    return !!limitItem
  } catch (error) {
    console.error('Package limit kontrolü sırasında hata:', error)
    return false
  }
}

/**
 * Kullanıcının PROJECTS için limit kontrolü yapar
 * @returns {boolean} - PROJECTS limit kontrolü sonucu
 */
export const packageLimit = (flag, limit = 1) => hasPackageLimit(flag, limit)

/**
 * Kullanıcının tüm packageLimits bilgilerini döndürür
 * @returns {Array} - packageLimits array'i
 */
export const getPackageLimits = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))
    return userData?.packageLimits || []
  } catch (error) {
    console.error('Package limits alınırken hata:', error)
    return []
  }
}

/**
 * Belirli bir subject için mevcut limit değerini döndürür
 * @param {string} subject - Kontrol edilecek subject
 * @returns {number} - Mevcut limit değeri (bulunamazsa 0)
 */
export const getSubjectLimit = subject => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))

    if (!userData || !userData.packageLimits || !Array.isArray(userData.packageLimits)) {
      return 0
    }

    const limitItem = userData.packageLimits.find(item => item.subject === subject)
    return limitItem ? limitItem.limit : 0
  } catch (error) {
    console.error('Subject limit alınırken hata:', error)
    return 0
  }
}
